// extracted by mini-css-extract-plugin
export var arrows = "_94-6";
export var decrementer = "_94-a";
export var disabled = "_94-4";
export var error = "_94-1";
export var hiddenText = "_94-b";
export var incrementer = "_94-9";
export var input = "_94-8";
export var inputWrapper = "_94-0";
export var leadingIcon = "_94-c";
export var readonly = "_94-3";
export var regular = "_94-7";
export var small = "_94-5";
export var warning = "_94-2";